import {GameGrid} from "js/Elements/GameGrid";
import {Vec2} from "js/Elements/types";
import {game} from "js/main";

export class BubblesMatchBehaviours {
  public static getMatchingBubbles(grid: GameGrid, cell: Vec2, bubbleType: number) {
    if (game.config.bubbleNames[bubbleType] === 'bomb') {
      return this.getMatchingForBomb(grid, cell);
    }
    return this.getMatchingDefault(grid, cell, bubbleType);
  }

  private static getMatchingForBomb(grid: GameGrid, cell: Vec2) {
    const coords: Set<string> = new Set();
    const toCheck: Set<Vec2> = new Set();

    coords.add(this.bubbleToKey({ cellX: cell.x, cellY: cell.y }))
    toCheck.add(cell);

    const bombRange = 3;

    for (let i = 0; i < bombRange; i++) {
      const coordsToCheck = [...toCheck.values()];
      toCheck.clear();
      coordsToCheck.forEach((placeToCheck) => {
        grid.getNeighbours(placeToCheck.x, placeToCheck.y).forEach((suggestedBubble) => {
          const key = this.bubbleToKey(suggestedBubble)
          if (coords.has(key)) return;
          coords.add(key);
          toCheck.add({ x: suggestedBubble.cellX, y: suggestedBubble.cellY});
        });
      });
    }

    return [...coords.values()].map(this.keyToVec2);
  }

  private static getMatchingDefault(grid: GameGrid, cell: Vec2, bubbleType: number) {
    let toCheck: Vec2[] = [cell];
    let toCheckIndex = 0;
    const checked = new Set<string>();
    checked.add(this.bubbleToKey({ cellX: cell.x, cellY: cell.y }));

    // a bit worrying
    // if (!this.getBubble(cellX, cellY)) return false;

    const found: Vec2[] = [cell];

    let i = 0;

    while (toCheckIndex < toCheck.length) {
      if (i++ > 100) break;
      const neighbours = grid.getNeighbours(toCheck[toCheckIndex].x, toCheck[toCheckIndex].y);
      toCheckIndex++;
      for (let i = 0; i < neighbours.length; i++) {
        const neighbour = neighbours[i];
        if (neighbour && !checked.has(this.bubbleToKey(neighbour)) && neighbour.isMatchingType(bubbleType)) {
          found.push({x: neighbour.cellX, y: neighbour.cellY });
          checked.add(this.bubbleToKey(neighbour));
          toCheck.push({x: neighbours[i].cellX, y: neighbours[i].cellY});
        }
      }
    }

    return found.length > 2 ? found : [];
  }

  private static bubbleToKey(bubble: { cellX: number, cellY: number}) {
    return `${bubble.cellX}_${bubble.cellY}`;
  }

  private static keyToVec2(key: string): Vec2 {
    const [x, y] = key.split('_');
    return { x: parseInt(x), y: parseInt(y) };
  }
}
